import { mapGetters } from "vuex";

export default {
    name: "ComsobaseCourseHero",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar"
      })
    },
    methods: {}
}
